export const EVENT_INTERACTION = 'EventInteraction';
export enum EventInteractions {
    Impression = 'impression',
    Click = 'click',
    Hover = 'hover',
}
export const HEAP_EVENT_CARD_CLICK = 'EventCardClick';
